import { ExternalTokenizer } from '@lezer/lr';
import { bodyContent } from './parser.terms';

export const bodyTokens = new ExternalTokenizer((input) => {
  let length = 0;

  while (input.next >= 0) {
    input.advance();
    length++;
  }

  if (length > 0) {
    input.acceptToken(bodyContent);
  }
});
